/**
 * @generated SignedSource<<5986db98d1ccb2c1530c403d469b3a62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateSisenseJwtInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateSisenseJwtMutation$variables = {
  input: CreateSisenseJwtInput;
};
export type CreateSisenseJwtMutation$data = {
  readonly createSisenseJwt: {
    readonly jwt: string | null;
  } | null;
};
export type CreateSisenseJwtMutation = {
  variables: CreateSisenseJwtMutation$variables;
  response: CreateSisenseJwtMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSisenseJwtPayload",
    "kind": "LinkedField",
    "name": "createSisenseJwt",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jwt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSisenseJwtMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSisenseJwtMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cd9a40683c83e5f0f500549527734896",
    "id": null,
    "metadata": {},
    "name": "CreateSisenseJwtMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSisenseJwtMutation(\n  $input: CreateSisenseJwtInput!\n) {\n  createSisenseJwt(input: $input) {\n    jwt\n  }\n}\n"
  }
};
})();

(node as any).hash = "b35937806e3ee8225d2fa1af12aefe98";

export default node;
